import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class ServiceValidationsTemplatesTableComponent implements IController {

  templates: any;
  canEdit: boolean;
  canDelete: boolean;
  templateSettingsMap: any;
  canReset: boolean;
  onEdit: Function;
  onDelete: Function;
  onReset: Function;
  onSettingsValueChange: Function;
  onChangeEnabledPurposes: Function;

  constructor() {
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('serviceValidationsTemplatesTable', {
    bindings: {
      templates: '<',
      canEdit: '<?',
      canDelete: '<?',
      canReset: '<?',
      templateSettingsMap: '<?',
      onEdit: '&',
      onDelete: '&',
      onReset: '&',
      onSettingsValueChange: '&',
      onChangeEnabledPurposes: '&'
    },
    template: require('./service-validations-templates-table.html').default,
    controller: ServiceValidationsTemplatesTableComponent
  });
